import { HttpContextToken } from '@angular/common/http';

/** When true, response interceptor will not show a global success toast. */
export const SKIP_SUCCESS_TOAST = new HttpContextToken<boolean>(() => false);
